import React, { Fragment, useEffect, useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import {
  SlButton,
  SlSelect,
  SlOption,
  SlIcon,
  SlDrawer,
} from "@shoelace-style/shoelace/dist/react";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import api from "../../services/api";
import AddPosition from "./AddPosition";
import { useNavigate } from "react-router";
import { roles, languageOptions, stateOptions, langoptions_preview, capitalizeFirstLetter, slotOptions } from "../../utils/constants";
import InternalAds from "./InternalAds";
import { Toast } from "../../shared/Toast";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { ScrollContainer } from "react-indiana-drag-scroll";
import "react-json-view-lite/dist/index.css";
import FilterSvg from "../../assets/images/filter.svg";
import SeriAlSvg from "../../assets/images/serial_no_icon.svg";
import SerialColoredSvg from "../../assets/images/serial_no_icon_colored.svg";
import editSvg from "../../assets/images/edit_icon_copy.svg";
import DeleteSvg from "../../assets/images/delete_icon.svg";
import AddSvg from "../../assets/images/add_plus_icon.svg";
import { formatDateWithTime } from "../../utils/dateFormat";
import { JsonView } from "react-json-view-lite";

// const ADTYPE_OPTIONS_PREVIEW = {
//   magicbid: "Magicbid",
//   gam: "GAM",
//   gam_with_nimbus: "GAM with Nimbus",
//   gam_with_nimbus_amazon: "GAM with Nimbus Amazon",
//   gam_with_amazon: "GAM with Amazon",
//   nimbus: "Nimbus",
//   nimbus_with_amazon: "Nimbus with Amazon",
//   admob: "Admob",
// };

const Slots = {
  0: "A",
  1: "B",
  2: "C",
};

const getLevelName = (item) => {
    if(item?.level === 'constituencyAd') return 'constituencyAdIds'
    if(item?.level === 'mandalAd') return 'mandalAdIds'
    if(item?.level === 'villageAd') return 'villageAdIds'
    if(item?.level === 'distAd') return 'districtAdIds'
    if(item?.level === 'stateAd') return 'stateAdIds'
    if(item?.level === 'langAd') return 'langAdIds'
    return item?.level + 'Ids'
}
export const getPositionClassName = (data) => {
    const order = ['widgetAds','langAdIds', 'stateAdIds', 'districtAdIds', 'constituencyAdIds', 'gamAds',, 'backfillAds'];
    let classes = new Set();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const obj = data[key];
        let cnt = 0;
        if(key == 'widgetAds'){
          for (const keypair of obj){
            cnt += +keypair.view
          }
          if(cnt > 0){
            classes.add('widgetAds')
          }
          continue
        }
        for (const subKey in obj) {
          if (subKey !== "rotation" && Array.isArray(obj[subKey]) && obj[subKey].length > 0) {
            if(subKey !== 'villageAdIds')
              classes.add(subKey);
          }
        }
      }
    }
  
    if (classes.size === 0) {
      return '';
    }
  
    if (classes.size > 1) {
      let orderedClasses = [...classes].sort((a, b) => order.indexOf(a) - order.indexOf(b));
      let availableColors =orderedClasses.map((color) => {
        return color === 'langAdIds' ? '#15803D' :
               color === 'stateAdIds' ? '#8200be' :
               color === 'districtAdIds' ? '#EA580C' :
               color === 'constituencyAdIds' ? '#2563EB' :
               color === 'gamAds' ? '#0D9488' :
               color === 'widgetAds' ? '#E879F9':
               color === 'backfillAds' ? '#E879F9' : '';
      }).filter(Boolean);  // Remove any empty strings
  
      if (availableColors.length > 1) {
        const colorStops = availableColors.map((color, index) => {
          return `${color} ${(index * 100) / availableColors.length}%, ${color} ${(index + 1) * 100 / availableColors.length - 1}%`;
        }).join(', ');

        const gradientString = `linear-gradient(to right, ${colorStops})`;
        const stripeString = `repeating-linear-gradient(to right, white 0, white 1px, transparent 1px, transparent 2px)`;
      return `${gradientString}, ${stripeString}`
      } else {
        return '';
      }
    } else {
      let val = classes.values().next().value;
      return `active ${val === 'langAdIds' ? 'lang' :
                      val === 'stateAdIds' ? 'state' :
                      val === 'districtAdIds' ? 'dist' :
                      val === 'constituencyAdIds' ? 'mand' :
                      val === 'gamAds' ? 'gam' :
                      val === "backfillAds" ? "backfill" : ""}`;
    }
  };
export const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
  };

// Builds the position-badge donut: hard-edged conic arcs per targeting
// dimension (sized by ad count) + a grey remainder, matching the design.
// Order matches DIMENSION_LEGEND: Language, State, District, Zone, Constituency, GAM, Backfill.
const DONUT_COLORS = ['#15803D', '#8200be', '#EA580C', '#fa166e', '#2563EB', '#0D9488', '#E879F9'];
export const buildDonutFromCounts = (counts = []) => {
  const segs = [];
  let total = 0;
  counts.forEach((c, i) => {
    if (c > 0) { segs.push([DONUT_COLORS[i], c]); total += c; }
  });
  // No ads at this position → a single grey ring.
  if (total === 0) return 'conic-gradient(#e2e5e9 0 100%)';
  // Colours sized by count, then a soft grey remainder (~40%) so each donut
  // reads as "partially full" — matches the design reference.
  const grey = Math.max(1, Math.round(total * 0.4));
  const parts = [...segs, ['#EAEDF0', grey]];
  const grand = total + grey;
  let acc = 0;
  const stops = parts.map(([color, w]) => {
    const start = acc;
    acc += (w / grand) * 100;
    return `${color} ${start.toFixed(2)}% ${acc.toFixed(2)}%`;
  });
  return `conic-gradient(${stops.join(', ')})`;
};

// Per-position ad counts, in DONUT_COLORS order: the five targeting dimensions
// (summed across slots) plus GAM network ads and Backfill ads.
export const positionDonutCounts = (posData) => {
  const dims = ["langAdIds", "stateAdIds", "districtAdIds", "zoneAdIds", "constituencyAdIds"].map((k) => {
    let c = 0;
    for (let s = 0; s < 3; s++) c += posData?.[s]?.[k]?.length || 0;
    return c;
  });
  return [
    ...dims,
    posData?.[3]?.gamAds?.length || 0,
    posData?.[3]?.backfillAds?.length || 0,
  ];
};

// Colour key for the position strip / badge donut (shown as a legend).
export const DIMENSION_LEGEND = [
  ["Language", "#15803D"],
  ["State", "#8200be"],
  ["District", "#EA580C"],
  ["Zone", "#fa166e"],
  ["Constituency", "#2563EB"],
  ["GAM", "#0D9488"],
  ["Backfill", "#E879F9"],
];

function AdUnit() {
  const [adData, setAdData] = useState({});
  const [backFillData,setBackfillData] = useState({});
  const [addPosition, setAddPosition] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState();
  const [internalAds, setInternalAds] = useState([]);
  const [showInternalAds, setShowInternalAds] = useState(false);
  const [loader, setLoader] = useState(false);
  const [editData, setEditData] = useState();
  const [editFlag, setEditFlag] = useState(false);
  const [adCounts, setAdCounts] = useState({
    panel: 0,
    gam: 0,
    backfill: 0,
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [langfilter, setLangFilter] = useState("1");
  const [statefilter, setStatefilter] = useState(-1);
  const [districtselect, setSelectdistrict] = useState(-1);
  const [districtfilter, setDistrictfilter] = useState([]);
  const [selectCostituency, setSelectedConstituency] = useState(-1);
  const [constituencyfilter, setConstituencyfilter] = useState([]);
  const [target_filter, setTarget_filter] = useState({
    lang_id: "1",
    state_id: -1,
    district_id: "-1",
    constituency_id: "-1",
    zone_id: -1,
  });
  const [showRemoveAlert, setShowRemoveAlert] = useState(false);
  const [removeClicked, setRemoveClicked] = useState(false);
  const [removeData, setRemoveData] = useState({});
  const [gam, setGam] = useState(false);
  const [addFrom, setAddFrom] = useState("");
  const [backfill, setBackfill] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [allPositions, setAllPositions] = useState(false);
  const [slot, setSlot] = useState();
  const [scheduled, setScheduled] = useState(false)
  const [netAdmoveToPop, setNetAdmoveToPop] = useState(null)
  const [netAdmoveToLoader, setNetAdmoveToLoader] = useState(null)
  const [panelAdmoveToPop, setPanelAdmoveToPop] = useState(false)
  const [panelAdmoveToLoader, setPanelAdmoveToLoader] = useState(null)
  const [netAdmoveToLogs, setNetAdmoveToLogs] = useState([])
  const [netAdmoveTodate, setNetAdmoveTodate] = useState({ startDate: "", endDate: "" })
  const [netAdmoveToLogsLoader, setNetAdmoveToLogsLoader] = useState(null)
  const [zoneOptions, setZoneOptions] = useState([]);
  const [selectedZone, setSelectedZone] = useState(-1);
  const [todayExecutedCampaigns, setTodayExecutedCampaigns] = useState(null);
  const [showTodayExecutedDrawer, setShowTodayExecutedDrawer] = useState(false);
  const navigate = useNavigate();
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const LanguageFilterChange = async (e) => {
    setLangFilter(e.target.value);
    setDistrictfilter([]);
    setConstituencyfilter([]);
    setCurrentPage(0);
    setTarget_filter({
      lang_id: e.target.value,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    });
    fetchAds(currentPage, {
      lang_id: e.target.value,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    });
    fetchZonesByLang(e.target.value);
    if (parseInt(e.target.value) === -1) {
      setStatefilter(-1);
      setLangFilter(-1);
      setSelectdistrict(-1);
      setSelectedConstituency(-1);
      setSelectedZone(-1);
    }
  };

  const fetchZonesByLang = async (lang_id) => {
    try {
    let zoneOptions = await api({
      url: "/location/getZones",
      method: "POST",
      responseType: "json",
      data: { lang_id },
    });
    if(zoneOptions?.code === 200){
      let zoneOptionsArr = [];
      for await (let item of zoneOptions.data || []) {
        const temp = { value: item.zone_id, label: `${item.zone_name}` };
        zoneOptionsArr.push(temp);
      }
        setZoneOptions(zoneOptionsArr);
    } else {
        setZoneOptions([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const ZoneFilterChange = async (value) => {
    setSelectedZone(value);
    setStatefilter(-1);
    setSelectdistrict(-1);
    setSelectedConstituency(-1)
    setTarget_filter({
      lang_id: target_filter.lang_id,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: value,
    });

    fetchAds(currentPage, {
      lang_id: target_filter.lang_id,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: value,
    });
  };
  const StateFilterChange = async (value) => {
    setStatefilter(value);
    setConstituencyfilter([]);
    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [value], langs: [langfilter] },
        });
        let districts = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.dist_name}` };
          districts.push(temp);
        }
        setDistrictfilter(districts);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict(-1);
      setStatefilter(-1);
      setSelectedConstituency(-1);
    }
    setTarget_filter({
      lang_id: target_filter.lang_id,
      state_id: value,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1
    });
    fetchAds(currentPage, {
      lang_id: target_filter.lang_id,
      state_id: value,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1
    });
  };

  const DistrictFilterChanger = async (value) => {
    setSelectdistrict(value);
    setConstituencyfilter([]);
    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getConstituentsnew",
          method: "POST",
          responseType: "json",
          data: { districts: [value], langs: [langfilter] },
        });
        let mandals = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.const_name}` };
          mandals.push(temp);
        }
        setConstituencyfilter(mandals);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict(-1);
      setSelectedConstituency(-1);
    }
    setTarget_filter({
      district_id: value,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
      constituency_id: -1,
      zone_id: -1
    });
    fetchAds(currentPage, {
      district_id: value,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
      constituency_id: -1,
      zone_id: -1
    });
  };

  const constituencyFilterChange = async (value) => {
    setSelectedConstituency(value);
    setTarget_filter({
      district_id: target_filter.district_id,
      constituency_id: value,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
      zone_id: -1
    });
    fetchAds(currentPage, {
      district_id: target_filter.district_id,
      constituency_id: value,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
      zone_id: -1
    });
  };

  const fetchAds = async (
    page = 0,
    target_filter = {
      lang_id: 1,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    }
  ) => {
    setLoader(true);
    try {
      let res = await api({
        url: "/adunit/getAds",
        method: "POST",
        responseType: "json",
        data: { target_filter, scheduled },
      });
      if (res.code === 200) {
        if (res.data) setAdData(res.data);
        let backfill_data = {}
        Object.keys(res.data).forEach(key => {
            if(!res.data[key][3]?.backfillAds || res.data[key][3]?.backfillAds.length === 0)  return;
            backfill_data[key] = backfill_data[key] || {};
            res.data[key][3]?.backfillAds?.forEach(ad => {
                const levelKey = getLevelName(ad);
                backfill_data[key][levelKey] = backfill_data[key][levelKey] || [];
                backfill_data[key][levelKey].push(ad);
            });
        });
        setBackfillData(backfill_data)
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const removeFromPosition = async (data) => {
    let obj = { ...data };
    obj.campaign_name = undefined;

    try {
      let res = await api({
        url: "/adunit/publishUnit",
        method: "POST",
        responseType: "json",
        data: {
          ...data,
          action: 0,
          slot: 3,
        },
      });
      if (res.code === 200) {
        Toast("success", "Removed Successfully!");
        fetchAds(0, target_filter);
        setShowRemoveAlert(false);
        setRemoveData({});
      } else {
        Toast("error", res?.data?.message);
      }
      setRemoveClicked(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAds(currentPage, target_filter);
  }, [scheduled]);

  const handleScheduled = () =>{
      setScheduled(prev => !prev)
  }

  function hasNonEmptyArray(data) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const obj = data[key];
        for (const subKey in obj) {
          if (subKey !== "rotation" && subKey !== 'villageAdIds') {
            if (Array.isArray(obj[subKey]) && obj[subKey].length > 0) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  const SlotLength = Array.from({ length: 3 });


  const NetAdPauseResume = async(moveTo) => {
    try {
      setNetAdmoveToLoader(true)
      let res = await api({
        url: "/adunit/NetAdPauseResume",
        method: "POST",
        responseType: "json",
        data: {
          moveTo,
          lang_id: langfilter
        },
      });
      if(res.code === 200){
        fetchAds(0, target_filter)
       }
       setNetAdmoveToPop(null)
       setNetAdmoveToLoader(false)
    } catch (error) {
      console.error("Error @ NetAdPauseResume", error)
    }
  }

  const PanelAdPauseResume = async(moveTo) => {
    try {
      setPanelAdmoveToLoader(true)
      let res = await api({
        url: "/adunit/PanelAdPauseResume",
        method: "POST",
        responseType: "json",
        data: {
          moveTo,
          lang_id: langfilter
        },
        });
        if(res.code === 200){
          console.log("res", res)
          Toast("success", res?.data || "Something went wrong")
        }
        else{
          Toast("error", res?.data || "Something went wrong")
        }        
    }
    catch(error) {
      console.error("Error @ PanelAdPauseResume", error)
    }
    finally {
      setPanelAdmoveToLoader(false)
      setPanelAdmoveToPop(false)
    }
}


  const getNetAdmoveToLogs = async() => {
    try {
      setNetAdmoveToLogsLoader(true)
      let result = await api({
        url: "/adunit/getNetAdmoveToLogs",
        method: "POST",
        data: {lang_id: +langfilter, dateFilter: netAdmoveTodate}
      })
      setNetAdmoveToLogsLoader(false)
      if(result.code === 200){
        setNetAdmoveToLogs(result.data || [])
      }
    } catch (error) {
      console.error("Error @ getNetAdmoveToLogs", error)
    }
  }

  useEffect(() => {
    if(netAdmoveToLogsLoader !== null)
        getNetAdmoveToLogs()
  }, [netAdmoveTodate])

  const handleGamMandatory = async (position, gam_mand_status) => {
    console.log("handleGamMandatory")
    try {
      let result = await api({
        url: "/adunit/gamMandatory",
        method: "POST",
        data: {lang_id: +langfilter, position, changeTo: gam_mand_status ? 0 : 1}
      })
      if(result.code === 200){
        Toast("success", "Gam Mandatory Status Updated")
        fetchAds(0, target_filter)
      } else {
        Toast("error", result?.data?.message)
      }
    } catch (error) {
      console.error("Error @ handleGamMandatory", error)
    }
  }

  const fetchTodayExecutedCampaigns = async (position, slot) => {
    try {
      let result = await api({
        url: "/adunit/todayExecutedCampaigns",
        method: "POST",
        data: {lang_id: +langfilter, position, slot}
      })
      if(result.code === 200){
        console.log("result", result)
        setTodayExecutedCampaigns({...result.data, position, slot} || { DFPCampaigns: [], NonDFPCampaigns: [], DFPRunningCampaigns: [], position, slot });
        setShowTodayExecutedDrawer(true);
      } else {
        Toast("error", result?.data?.message)
      }
    } catch (error) {
      console.error("Error @ fetchTodayExecutedCampaigns", error)
    }
  }
  const GamMandatory = ({item}) => {
    return (
      <div>
        {adData[item][3]["backfillAds"].length > 0 ? (
          <div className="pos bFill active">
            {/* <div>
                        <label>Backfill</label>
                        <button onClick={() => {
                                      setInternalAds(
                                        adData[item][3]["backfillAds"]
                                      );
                                      setShowInternalAds(true);
                                      setSlot(3)
                                      setAddFrom("Backfill");
                                      setSelectedPosition(indexMain);
                                      setRotation(adData[item][3].rotation);
                                    }}>{adData[item][3]["backfillAds"].length}</button>
                        </div> */}
            <div onClick={() => handleGamMandatory(item, adData[item]["gam_mand"])}>
              <label className="cursor-pointer" title="Gam External Mandatory">
                GAM Mandatory
              </label>
              <div
                className={`
                              w-11 h-6 rounded-full transition-colors duration-200
                              ${adData[item]["gam_mand"] ? "bg-green-500" : "bg-red-500"}
                              peer-focus:ring-2 peer-focus:ring-green-300
                              after:content-['']
                              after:absolute after:top-0.5 after:left-0.5
                              after:bg-white after:border-gray-300 after:border
                              after:rounded-full after:h-5 after:w-5
                              after:transition-all after:duration-200
                              ${adData[item]["gam_mand"] ? "after:translate-x-5" : ""}
                            `}
                style={{ position: "relative" }}
              ></div>
            </div>
          </div>
        ) : (
          <div className="pos bFill">
            {/* <div>
                            <label>Backfill</label>
                            <button className="addBtn" onClick={() => {
                                
                                        setAddPosition(true);
                                        setSelectedPosition(indexMain);
                                        setBackfill(true);
                                        setSlot(3)
                                        setRotation(adData[item][3].rotation);}
                                    
                                    }><img src={AddSvg} alt="Add" /> <span>Add</span></button>
                                    </div> */}
            <div onClick={() => handleGamMandatory(item, adData[item]["gam_mand"])}>
              <label className="cursor-pointer" title="Gam External Mandatory">
                GAM Mandatory
              </label>
              <div
                className={`
                              w-11 h-6 rounded-full transition-colors duration-200
                              ${adData[item]["gam_mand"] ? "bg-green-500" : "bg-red-500"}
                              peer-focus:ring-2 peer-focus:ring-green-300
                              after:content-['']
                              after:absolute after:top-0.5 after:left-0.5
                              after:bg-white after:border-gray-300 after:border
                              after:rounded-full after:h-5 after:w-5
                              after:transition-all after:duration-200
                              ${adData[item]["gam_mand"] ? "after:translate-x-5" : ""}
                            `}
                style={{ position: "relative" }}
              ></div>
            </div>
          </div>
        )}
      </div>
    );
  };
  useEffect(() => {
    if(langfilter !== -1)
      fetchZonesByLang(+langfilter);
  }, []);

  const onChangeAdunitSlotStatus = async(id, status) => { 
    try {
      let res = await api({
        url: "/makerchecker/adunitPosSlotStatusRequest",
        method: "POST",
        data: {id, status : status ? 0 : 1}
      })
      if(res.code === 200){
        Toast("success", res?.data?.message || "Request sent successfully")
      }
      else{
        Toast("error", res?.data?.message || "Request not sent")
      }
      fetchAds(0, target_filter);
    } catch (error) {
      Toast("error", error?.response?.data?.message || "Request not sent")
    }
  }
  return (
    <>
    <div className="adUnitStickyHead">
      <h5>Ad Units</h5>
      <div className="d-flex gap-3 justify-content-end mobileNegFil">
        <div className="flex items-center gap-3">
          <aside className="flex items-center gap-3 justify-center mobHide">
            {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.salesperson}

            {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.salesperson && (
                <div>
                  <SlSelect
                    placeholder="Select Language"
                    name="lang"
                    size="small"
                    onSlChange={LanguageFilterChange}
                    value={langfilter}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    {/* <SlOption value="-1">All</SlOption> */}
                    {languageOptions.map((item) => {
                      return (
                        <SlOption key={item.value} value={item.value}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}
            {
              langfilter !== -1 && statefilter === -1 && (
                <div>
                  <SlSelect
                    placeholder="Select Zone"
                    name="zone"
                    size="small"
                    onSlChange={(e) => {
                      ZoneFilterChange(e.target.value);
                    }}
                  >
                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {zoneOptions.map((item) => {
                      return (
                        <SlOption key={item.value} value={item.value}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )
            }  
            { +selectedZone === -1 ? <>
            {langfilter !== -1 && (
              <div>
                <SlSelect
                  placeholder="Select State"
                  name="state"
                  size="small"
                  onSlChange={(e) => {
                    setSelectedZone(-1);
                    StateFilterChange(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {stateOptions
                    .filter((item) => item.lang_id === +langfilter)
                    .map((item) => {
                      return (
                        <SlOption key={item.state_id} value={item.state_id}>
                          {item.state_name}
                        </SlOption>
                      );
                    })}
                </SlSelect>
              </div>
            )}
            {statefilter !== -1 && (
              <div>
                <SlSelect
                  placeholder="Select District"
                  name="district"
                  size="small"
                  onSlChange={(e) => {
                    DistrictFilterChanger(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {districtfilter.map((item) => {
                    return (
                      <SlOption
                        key={item.value.dist_id}
                        value={item.value.dist_id}
                      >
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
            )}

            {districtselect !== -1 && (
              <div>
                <SlSelect
                  placeholder="Select Constituency"
                  name="Constituency"
                  size="small"
                  onSlChange={(e) => {
                    constituencyFilterChange(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {constituencyfilter.map((item) => {
                    return (
                      <SlOption
                        key={item.value.const_id}
                        value={item.value.const_id}
                      >
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
            )}
            </> : null}
          </aside>
          <img
            src={FilterSvg}
            alt="Filter"
            onClick={() => setShowFilter(true)}
            className="w-8 ml-auto mobileOnly"
          />
        </div>

        <SlButton
          variant="primary"
          className="d-flex align-items-end"
          size="small"
          onClick={() => {
            setAddPosition(true);
            setAddFrom("main");
          }}
        >
          New Position
        </SlButton>
      </div>
      <div id="filterRadios">
        <h6>Positions</h6>
        <div className="r-contain">
            <input type="radio" name="radio" id="radio2" defaultChecked={!allPositions} onClick={()=>{
                setAllPositions(false);
            }}/>
            <label for="radio2">Show Active Only</label>
        </div>
        <div className="r-contain">
            <input type="radio" name="radio" id="radio1" defaultChecked={allPositions}  onClick={()=>{
                setAllPositions(true);
            }}/>
            <label for="radio1">All Positions</label>
        </div>
        <div className="color-legend">
          {DIMENSION_LEGEND.map(([label, color]) => (
            <span className="cl-item" key={label} title={label}>
              <span className="cl-dot" style={{ backgroundColor: color }} />
              {label}
            </span>
          ))}
        </div>
      </div>
      <div className="posList">
                <ul>
                {Object.keys(adData).map((item, indexMain) => {
                return (hasNonEmptyArray(adData[item]) || allPositions ? 
                  <li
                    key={`${item}-${JSON.stringify(adData[item])}`} // More unique key
                    style={{
                      backgroundImage: getPositionClassName(adData[item]),
                      backgroundRepeat: "no-repeat",
                      backgroundSize: 'cover'
                    }}
                    className={getPositionClassName(adData[item]).includes('linear') ? 'active' : getPositionClassName(adData[item])}
                    onClick={() => {scrollToSection(`ad-${indexMain}`); setSelectedPosition(indexMain)}}
                  >
                    {indexMain}
                  </li> : null)
              }).filter(i => i)}
                </ul>
            </div>

      <div className="NetAdPauseResume">
      <button title="Pause and Resume All Panel Ads" className="border border-gray-300 rounded-sm py-0.5 px-1 hover:bg-gray-50 transition-colors d-flex items-center gap-1" onClick={() => { setPanelAdmoveToPop(true)}}>
        <SlIcon library="lucide" name="power"></SlIcon>
        <span className="mobHide">Pause and Resume All Panel Ads</span>
      </button>
      <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={scheduled}
                onChange={handleScheduled}
                id="schedule"
              />
              <label className="form-check-label" htmlFor="schedule">
                Show Scheduled
              </label>
            </div>
            <button title="Pause All Network Ads" className="pauseAds" onClick={() => { setNetAdmoveToPop(0)}}><span className="mobHide">Pause All Network Ads</span></button>
            <button title="Resume All Network Ads" className="resumeAds" onClick={() => { setNetAdmoveToPop(1)}}><span className="mobHide">Resume All Network Ads</span></button>
          <div className="d-flex items-center cursor-pointer" onClick={() => {getNetAdmoveToLogs()}}>
            <sl-tooltip content="Network Ad logs" hoist>
              <sl-icon-button
                library="lucide"
                name="terminal-square"
                onClick={() => { }}></sl-icon-button>
            </sl-tooltip>
            <span className="mobHide">Network Ad logs</span>
          </div>
          </div>
      </div>
      <div className="my-2 p-1">
        <ScrollContainer>
        <div className="adunit-container" >
          {!loader && Object.keys(adData)?.length ? (
            Object.keys(adData).map((item, indexMain) => {
              const activeSlots = SlotLength.filter((_, i) => adData[item]?.[i]?.adunit_pos_slot_status_details?.status).length;
              const netCount = adData[item]?.[3]?.["gamAds"]?.length || 0;
              const donutBg = buildDonutFromCounts(positionDonutCounts(adData[item]));
              return hasNonEmptyArray(adData[item]) || allPositions ? (
                <>
                  <div id={`ad-${indexMain}`} className={`unitCard ${
                    selectedPosition === indexMain &&
                     "active" }`} key={indexMain}>
                    <div className="posNum" style={{ "--donut": donutBg }}>
                      <img src={showInternalAds &&
                    selectedPosition === indexMain &&
                    addFrom !== "Backfill" &&
                    addFrom !== "main" ? SerialColoredSvg :SeriAlSvg} alt="Position Number" />
                      <span>{item}</span>
                      <small className="posOn">{activeSlots}/3 on</small>
                      <small className="netTag">{netCount} network</small>
                    </div>
                    <div className="panelAds tableType slotTable">
                        <div className="secTitle">Panel Ads</div>
                        <div className="posTypeRow posTypeHead">
                            <div className="posHead">
                                <label>&nbsp;</label>
                            </div>
                            <div className="posHead">
                                <label>Language</label>
                            </div>
                            <div className="posHead">
                                <label>State</label>
                            </div>
                            <div className="posHead">
                                <label>District</label>
                            </div>
                             <div className="posHead">
                                <label>Zone</label>
                            </div>
                            <div className="posHead">
                                <label>Constituency</label>
                            </div>
                        </div>
                        {SlotLength.map((slot, index) => {
                        return (
                        <div className={`posTypeRow ${!adData[item][index].adunit_pos_slot_status_details?.status ? 'slot-disabled' : ''}`}>
                            <div className="headRow">
                              {adData[item][index].adunit_pos_slot_status_details?.mca_status ? (
                                <sl-tooltip content="Request Pending">
                                  <span className="adunit-checkbox-wrap has-pending">
                                    <span className="adunit-checkbox-pending-dot" />
                                    <button
                                      type="button"
                                      role="switch"
                                      aria-checked={adData[item][index].adunit_pos_slot_status_details?.status || false}
                                      className={`adunit-pos-slot-toggle ${adData[item][index].adunit_pos_slot_status_details?.status ? 'is-checked' : 'is-unchecked'}`}
                                      onClick={() => onChangeAdunitSlotStatus(adData[item][index].adunit_pos_slot_status_details?.id, adData[item][index].adunit_pos_slot_status_details?.status)}
                                    >
                                      {adData[item][index].adunit_pos_slot_status_details?.status ? (
                                        <SlIcon library="lucide" name="check" className="adunit-toggle-icon" />
                                      ) : (
                                        <SlIcon library="lucide" name="x" className="adunit-toggle-icon" />
                                      )}
                                    </button>
                                  </span>
                                </sl-tooltip>
                              ) : (
                                <span className="adunit-checkbox-wrap">
                                  <button
                                    type="button"
                                    role="switch"
                                    aria-checked={adData[item][index].adunit_pos_slot_status_details?.status || false}
                                    className={`adunit-pos-slot-toggle ${adData[item][index].adunit_pos_slot_status_details?.status ? 'is-checked' : 'is-unchecked'}`}
                                    onClick={() => onChangeAdunitSlotStatus(adData[item][index].adunit_pos_slot_status_details?.id, adData[item][index].adunit_pos_slot_status_details?.status)}
                                  >
                                    {adData[item][index].adunit_pos_slot_status_details?.status ? (
                                      <SlIcon library="lucide" name="check" className="adunit-toggle-icon" />
                                    ) : (
                                      <SlIcon library="lucide" name="x" className="adunit-toggle-icon" />
                                    )}
                                  </button>
                                </span>
                              )}
                              <span className="pos-slot-label" onClick={() => {fetchTodayExecutedCampaigns(indexMain, index)}} style={{ cursor: 'pointer', userSelect: 'none', transition: 'all 0.2s ease' }} onMouseEnter={(e) => e.target.style.opacity = '0.7'} onMouseLeave={(e) => e.target.style.opacity = '1'}>{Slots[index]}</span>
                            {adData[item][index].rotation ? (
                          <sl-tooltip content="Rotation">
                            <span className="adunit-rotation-icon-wrap">
                              <SlIcon
                                library="lucide"
                                name="refresh-ccw"
                              ></SlIcon>
                            </span>
                          </sl-tooltip>
                        ) : null}
                            </div>
                            <div className={`pos language ${
                                adData[item][index]["langAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(adData[item][index]["langAdIds"] || []);
                                setShowInternalAds(true);
                                setAddFrom(1);
                                setRotation(adData[item][index].rotation);
                                setSelectedPosition(indexMain);
                                setSlot(index)
                              }}
                              disabled={!adData[item][index].adunit_pos_slot_status_details?.status}
                              style={{ cursor: !adData[item][index].adunit_pos_slot_status_details?.status ? 'not-allowed' : 'pointer' }}
                              title={!adData[item][index].adunit_pos_slot_status_details?.status ? "This slot is disabled. Please raise a request to enable it." : ""}
                              >{adData[item][index]["langAdIds"]?.length || 0}</button>
                            </div>

                            <div className={`pos state ${
                                adData[item][index]["stateAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(adData[item][index]["stateAdIds"] || []);
                                setShowInternalAds(true);
                                setAddFrom(2);
                                setSlot(index)
                                setSelectedPosition(indexMain);
                                setRotation(adData[item][index].rotation);
                              }}
                              disabled={!adData[item][index].adunit_pos_slot_status_details?.status}
                              style={{ cursor: !adData[item][index].adunit_pos_slot_status_details?.status ? 'not-allowed' : 'pointer' }}
                              title={!adData[item][index].adunit_pos_slot_status_details?.status ? "This slot is disabled. Please raise a request to enable it." : ""}
                              >{adData[item][index]["stateAdIds"]?.length || 0}</button>
                            </div>
                            <div className={`pos district ${
                                adData[item][index]["districtAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(adData[item][index]["districtAdIds"] || []);
                                setShowInternalAds(true);
                                setAddFrom(3);
                                setSlot(index)
                                setRotation(adData[item][index].rotation);
                                setSelectedPosition(indexMain);
                              }}
                              disabled={!adData[item][index].adunit_pos_slot_status_details?.status}
                              style={{ cursor: !adData[item][index].adunit_pos_slot_status_details?.status ? 'not-allowed' : 'pointer' }}
                              title={!adData[item][index].adunit_pos_slot_status_details?.status ? "This slot is disabled. Please raise a request to enable it." : ""}
                              >{adData[item][index]["districtAdIds"]?.length || 0}</button>
                            </div>
                                                        <div className={`pos zone ${
                                adData[item][index]["zoneAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(adData[item][index]["zoneAdIds"] || []);
                                setShowInternalAds(true);
                                setAddFrom(5);
                                setSlot(index)
                                setRotation(adData[item][index].rotation);
                                setSelectedPosition(indexMain);
                              }}
                              disabled={!adData[item][index].adunit_pos_slot_status_details?.status}
                              style={{ cursor: !adData[item][index].adunit_pos_slot_status_details?.status ? 'not-allowed' : 'pointer' }}
                              title={!adData[item][index].adunit_pos_slot_status_details?.status ? "This slot is disabled. Please raise a request to enable it." : ""}
                              >{adData[item][index]["zoneAdIds"]?.length}</button>
                            </div>
                            <div className={`pos mandal ${
                                adData[item][index]["constituencyAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(adData[item][index]?.["constituencyAdIds"] || []);
                                setShowInternalAds(true);
                                setRotation(adData[item][index].rotation);
                                setAddFrom(4);
                                setSlot(index)
                                setSelectedPosition(indexMain);
                              }}
                              disabled={!adData[item][index].adunit_pos_slot_status_details?.status}
                              style={{ cursor: !adData[item][index].adunit_pos_slot_status_details?.status ? 'not-allowed' : 'pointer' }}
                              title={!adData[item][index].adunit_pos_slot_status_details?.status ? "This slot is disabled. Please raise a request to enable it." : ""}
                              >{adData[item][index]?.["constituencyAdIds"]?.length}</button>
                            </div>  
                            
                        </div>)})}
                        
                    </div>
                    <div className="gamNetBfill">
                      <div className="secTitle">Network Ads · GAM</div>
                      <div className="flex items-center justify-between h-full">

                      {adData[item][3]["gamAds"].length  !== 0 ? <div className={"gamAd" + (adData[item][3]["gamAds"][0]?.ad_status ? '' : ' pausegamAd')}>
                          
                          <div className="flex  items-center justify-between">
                            <div className="w-1/2">
                            <label>GAM Network Ads:</label>
                            {Array.from({length:adData[item][3]["gamAds"].length}).map((it, index) => (
                           <div className="adType">
                              
                              <h3>{adData[item][3]["gamAds"][index].ad_name}</h3>
                            <button onClick={()=>{ setAddPosition(true);
                                  setSelectedPosition(indexMain);
                                  setGam(true);
                                  setEditData(adData[item][3]["gamAds"][index])
                                  setEditFlag(true)
                                  setRotation(adData[item][3].rotation);
                                }}>
                              <img src={editSvg} alt="Edit" className="max-w-fit" />
                            </button>
                            <button onClick={() => {
                                    setRemoveData({
                                      ad_type: "gam",
                                      sub_type:adData[item][3]["gamAds"][index].sub_type,
                                      backfill: false,
                                      ad_name:
                                        adData[item][3]["gamAds"][index].ad_name,
                                      ad_code:
                                        adData[item][3]["gamAds"][index].ad_code,
                                      native_type:
                                        adData[item][3]["gamAds"][index].native_type,
                                      net_id: adData[item][3]["gamAds"][index].net_id,
                                      source: adData[item][3]["gamAds"][index].source,
                                      design_type:
                                        adData[item][3]["gamAds"][index].design_type,
                                      lang_id: target_filter.lang_id,
                                      position: indexMain,
                                    });
                                    setShowRemoveAlert(true);
                                  }}>
                              <img src={DeleteSvg} alt="Delete"  className="max-w-fit" />
                            </button>
                            <SlIcon className={adData[item][3]["gamAds"][index]?.os === 0 ? '' :adData[item][3]["gamAds"][index]?.os === 1 ? 'text-green-700' :'text-gray-400'} name={adData[item][3]["gamAds"][index]?.os === 0 ? 'hypnotize' :adData[item][3]["gamAds"][index]?.os === 1 ? 'android2' :'apple'}></SlIcon>
                            {/* <div className="ads mobHide">
                              <label className="google">
                                {adData[item][3]["gamAds"][index].source}
                              </label>
                              <label className="nat-adv">
                                {adData[item][3]["gamAds"][index].native_type}
                              </label>
                            </div> */}
                              
                          </div> 
                            ))}
                             <button className="addBtn" onClick={() => {
                              setAddPosition(true);
                              setSelectedPosition(indexMain);
                              setGam(true);
                              setRotation(adData[item][3].rotation);
                            }}><img src={AddSvg} alt="Add" /> <span>Add</span></button>
                              </div>
                              <GamMandatory item = {item}/>
                            </div>
                        </div> : <div className="flex items-center justify-between"><div className="w-1/2"><div className="gamAd">
                      <label>GAM Network Ads:</label>
                      <button className="addBtn" onClick={() => {
                              setAddPosition(true);
                              setSelectedPosition(indexMain);
                              setGam(true);
                              setRotation(adData[item][3].rotation);
                            }}><img src={AddSvg} alt="Add" /> <span>Add</span></button>
                              </div>
                              <GamMandatory item = {item}/>
                              </div>
                  </div>}
 
                    </div>
                    </div>
                    <div className="panelAds tableType backfillTable">
                        <div className="secTitle">Backfill Targeting</div>
                        <div className="posTypeRow posTypeHead">
                            <div className="posHead">
                                <label>Language</label>
                            </div>
                            <div className="posHead">
                                <label>State</label>
                            </div>
                            <div className="posHead">
                                <label>District</label>
                            </div>
                            <div className="posHead">
                                <label>Zone</label>
                            </div>
                            <div className="posHead">
                                <label>Constituency</label>
                            </div>
                        </div>
                        <div className="posTypeRow">
                            <div className={`pos language ${
                                backFillData[item]?.["langAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(backFillData[item]?.["langAdIds"] || []);
                                setShowInternalAds(true);
                                setAddFrom("Backfill");
                                setRotation(backFillData[item]?.["rotation"] || 0);
                                setSelectedPosition(indexMain);
                                setSlot(0)
                              }}
                              >{backFillData[item]?.["langAdIds"]?.length || 0}</button>
                            </div>

                            <div className={`pos state ${
                                backFillData[item]?.["stateAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(backFillData[item]?.["stateAdIds"] || []);
                                setShowInternalAds(true);
                                setAddFrom("Backfill");
                                setSlot(0)
                                setSelectedPosition(indexMain);
                                setRotation(backFillData[item]?.["rotation"] || 0);
                              }}>{backFillData[item]?.["stateAdIds"]?.length || 0}</button>
                            </div>
                            <div className={`pos district ${
                                backFillData[item]?.["districtAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(backFillData[item]?.["districtAdIds"] || []);
                                setShowInternalAds(true);
                                setAddFrom("Backfill");
                                setSlot(0)
                                setRotation(backFillData[item]?.["rotation"] || 0);
                                setSelectedPosition(indexMain);
                              }}>{backFillData[item]?.["districtAdIds"]?.length || 0}</button>
                            </div>
                            <div className={`pos zone ${
                                backFillData[item]?.["zoneAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(backFillData[item]?.["zoneAdIds"] || []);
                                setShowInternalAds(true);
                                setAddFrom("Backfill");
                                setSlot(0)
                                setRotation(backFillData[item]?.["rotation"] || 0);
                                setSelectedPosition(indexMain);
                              }}>{backFillData[item]?.["zoneAdIds"]?.length || 0}</button>
                            </div>
                            <div className={`pos mandal ${
                                backFillData[item]?.["constituencyAdIds"]?.length > 0
                                  ? "active"
                                  : ""
                              }`}>
                                <button onClick={() => {
                                setInternalAds(backFillData[item]?.["constituencyAdIds"] || []);
                                setShowInternalAds(true);
                                setRotation(backFillData[item]?.["rotation"] || 0);
                                setAddFrom("Backfill");
                                setSlot(0)
                                setSelectedPosition(indexMain);
                              }}>{backFillData[item]?.["constituencyAdIds"]?.length || 0}</button>
                            </div>
                        </div>
                    </div>

                    
                    {/* <button className="addBtn" onClick={() => {
                              setSelectedPosition(indexMain);
                              setAddPosition(true);
                              setRotation(adData[item].rotation);
                              setAddFrom("main");
                              // setAdCounts({
                              // panel: categorizeObjects(adData[item], "panel")
                              // .length,
                              // gam: categorizeObjects(adData[item], "gam")
                              // .length,
                              // backfill: categorizeObjects(
                              // adData[item],
                              // "backfill"
                              // ).length,
                              // });
                            }}>
                      <img src={AddSvg} alt="Add" />
                      <span>Add</span>
                    </button> */}
                  </div>
                  {showInternalAds &&
                    selectedPosition === indexMain &&
                    addFrom !== "Backfill" &&
                    addFrom !== "main" ? (
                      <InternalAds
                      show={showInternalAds}
                        setShow={setShowInternalAds}
                        rotation={rotation}
                        internalAds={internalAds}
                        setInternalAds={setInternalAds}
                        position={selectedPosition}
                        setPosition={setSelectedPosition}
                        from={addFrom}
                        slot={slot}
                        target={target_filter}
                        fetchAds={fetchAds}
                      />
                    ) : null}
                     {showInternalAds &&
                            selectedPosition === indexMain &&
                            addFrom === "Backfill" ? (
                              <InternalAds
                              show={showInternalAds}
                                setShow={setShowInternalAds}
                                rotation={rotation}
                                internalAds={internalAds}
                                setInternalAds={setInternalAds}
                                position={selectedPosition}
                                setPosition={setSelectedPosition}
                                from={addFrom}
                                target={target_filter}
                                fetchAds={fetchAds}
                                slot={3}
                              />
                            ) : null}
                    </>
              ) : null;
            })
          ) : !Object.keys(adData)?.length && !loader ? (
            <div className="d-flex justify-center item">
               <div className='no-data'>
      <svg data-v-5eed88b5="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="bird-icon flip" strokeWidth="1"><path d="M16 7h.01"></path><path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"></path><path d="m20 7 2 .5-2 .5"></path><path d="M10 18v3"></path><path d="M14 17.75V21"></path><path d="M7 18a6 6 0 0 0 3.84-10.61"></path></svg>
        <h2>No Data Found</h2>
      </div>
          </div>
            
          ) : <div class="flex items-center gap-3 p-4 w-full justify-center">
  <span class="text-lg font-semibold">
    వస్తున్నా… యాడ్ డీటెయిల్స్ తెస్తున్నా<span class="text-gray-400">…</span>
  </span>

  <span class="flex items-end gap-1">
    <span class="h-2 w-2 rounded-full bg-gray-300 animate-bounce [animation-delay:-0.2s]"></span>
    <span class="h-2 w-2 rounded-full bg-gray-600 animate-bounce [animation-delay:-0.1s]"></span>
    <span class="h-2 w-2 rounded-full bg-black animate-bounce"></span>
  </span>
</div>
}
           </div>
        </ScrollContainer>
      </div>
      {addPosition && (
        <AddPosition
          show={addPosition}
          rotation={rotation}
          setRotation={setRotation}
          setShow={setAddPosition}
          position={selectedPosition}
          setPosition={setSelectedPosition}
          gam={gam}
          setGam={setGam}
          backfill={backfill}
          setBackfill={setBackfill}
          target_filter={target_filter}
          fetchAds={fetchAds}
          adCounts={adCounts}
          editData={editData}
          editFlag={editFlag}
          setEditFlag={setEditFlag}
          slot={slot}
        />
      )}
      <div>
        <Modal
          show={showRemoveAlert}
          onHide={() => {
            setShowRemoveAlert(false);
            setRemoveData({});
          }}
          backdrop="static"
          animation={false}
          dialogClassName="modal-30w"
          centered
        >
          <ModalHeader closeButton>
            <ModalTitle>
              <h3>Are you Sure ?(Remove Ad)</h3>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div>
              {/* <JsonView
                data={removeData}
                shouldExpandNode={allExpanded}
              ></JsonView> */}
              {removeData.campaign_name ? (
                <div>
                  <h6 className="capitalize">
                    LineItem: {removeData.campaign_name}
                  </h6>
                  <h6>Position: {removeData.position}</h6>
                </div>
              ) : (
                <div>
                  <h6 className="capitalize">
                    Ad Name: {`${removeData.ad_name}`}
                    <h6>Position: {removeData.position}</h6>
                  </h6>
                </div>
              )}
              <div className="d-flex gap-3 justify-content-end mt-3">
                <button
                  className="btn btn-primary btn-sm"
                  type="button"
                  onClick={() => {
                    setShowRemoveAlert(false);
                    setRemoveData({});
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  type="submit"
                  onClick={() => {
                    setRemoveClicked(true);
                    removeFromPosition(removeData);
                  }}
                  disabled={removeClicked}
                >
                  {removeClicked && (
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {removeClicked ? "Removing..." : "Remove"}
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => {}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <aside className="flex items-center gap-3 justify-center flex-wrap">
            {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.salesperson}

            {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.salesperson && (
                <div className="w-full">
                  <SlSelect
                    placeholder="Select Language"
                    name="lang"
                    size="medium"
                    onSlChange={LanguageFilterChange}
                    value={langfilter}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    {/* <SlOption value="-1">All</SlOption> */}
                    {languageOptions.map((item) => {
                      return (
                        <SlOption key={item.value} value={item.value}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}
            {langfilter !== -1 && (
              <div className="w-full">
                <SlSelect
                  placeholder="Select State"
                  name="state"
                  size="medium"
                  onSlChange={(e) => {
                    StateFilterChange(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {stateOptions
                    .filter((item) => item.lang_id === +langfilter)
                    .map((item) => {
                      return (
                        <SlOption key={item.state_id} value={item.state_id}>
                          {item.state_name}
                        </SlOption>
                      );
                    })}
                </SlSelect>
              </div>
            )}
            {statefilter !== -1 && (
              <div className="w-full">
                <SlSelect
                  placeholder="Select District"
                  name="district"
                  size="medium"
                  onSlChange={(e) => {
                    DistrictFilterChanger(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {districtfilter.map((item) => {
                    return (
                      <SlOption
                        key={item.value.dist_id}
                        value={item.value.dist_id}
                      >
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
            )}

            {districtselect !== -1 && (
              <div className="w-full">
                <SlSelect
                  placeholder="Select Constituency"
                  name="Constituency"
                  size="medium"
                  onSlChange={(e) => {
                    constituencyFilterChange(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {constituencyfilter.map((item) => {
                    return (
                      <SlOption
                        key={item.value.const_id}
                        value={item.value.const_id}
                      >
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
            )}
           
          </aside>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
      <div>
        <Modal
          show={netAdmoveToPop !== null}
          onHide={() => {
            setNetAdmoveToPop(null);
          }}
          // backdrop="static"
          animation={false}
          dialogClassName="modal-30w"
          centered
        >
          <ModalHeader closeButton>
            <ModalTitle>
              <h3>Are you Sure ?({netAdmoveToPop ? "Resume" : "Pause"})</h3>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div>
                <div>
                  <h6 className="capitalize">
                   {netAdmoveToPop ? "Resume" : "Pause"} All Network ads
                  </h6>
                </div>
              <div className="d-flex gap-3 justify-content-end mt-3">
                <button
                  className="btn btn-primary btn-sm"
                  type="button"
                  onClick={() => {
                    setNetAdmoveToPop(null)
                  }}
                >
                  Cancel
                </button>
                <button
                  className={`btn ${netAdmoveToPop ? "btn-success" : "btn-danger"} btn-sm`}
                  type="submit"
                  onClick={() => {
                    NetAdPauseResume(netAdmoveToPop)
                  }}
                  disabled={netAdmoveToLoader}
                >
                  {netAdmoveToLoader ? "Loading..." : netAdmoveToPop ? "Resume" : "Pause"}
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
      <div>
        <Modal
          show={panelAdmoveToPop}
          onHide={() => {
            setPanelAdmoveToPop(false);
          }}
          // backdrop="static"
          animation={false}
          dialogClassName="modal-30w"
          centered
        >
          <ModalHeader closeButton>
            <ModalTitle>
              <h3>Are you Sure ?</h3>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div>
                <div>
                  <h6 className="capitalize">
                     Pause and Resume All Panel ads
                  </h6>
                </div>
              <div className="d-flex gap-3 justify-content-end mt-3">
                <button
                  className="btn btn-primary btn-sm"
                  type="button"
                  onClick={() => {
                    setPanelAdmoveToPop(false)
                  }}
                >
                  Cancel
                </button>
                <button
                  className={`btn btn-success btn-sm`}
                  type="submit"
                  onClick={() => {
                    PanelAdPauseResume(true)
                  }}
                  disabled={panelAdmoveToLoader}
                >
                  {panelAdmoveToLoader ? "Loading..." : "Pause and Resume"}
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
      <SlDrawer
        open={netAdmoveToLogsLoader !== null}
        onSlRequestClose={() => { setNetAdmoveToLogsLoader(null); setNetAdmoveToLogs([]) }}
        onSlAfterHide={() => { }}
        style={{ "--size": "75vw" }}
        label={langoptions_preview[+langfilter]}
      >{console.log(netAdmoveToLogs)}
          <div className="border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66 mb-2">
            <Datepicker
              classNames="form-input"
              value={netAdmoveTodate}
              primaryColor={"cyan"}
              showShortcuts={true}
              // useRange={false}
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={(selectedDate) => {
                if (selectedDate.startDate && selectedDate.endDate) {
                  setNetAdmoveTodate(selectedDate);
                } else {
                  setNetAdmoveTodate({ startDate: null, endDate: null });
                }
              }}
            />
          </div>
          <div className="overflow-x-auto">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <td>Name</td>
                  <td>Action</td>
                  <td>Language</td>
                  <td>Time</td>
                  <td>AdCodes</td>
                </tr>
              </thead>
              {!netAdmoveToLogsLoader && netAdmoveToLogs?.length ? <tbody>
                {netAdmoveToLogs?.map((item) => {
                  return (
                    <tr key={item.log_id}>
                      <td>{capitalizeFirstLetter(item.name)}</td>
                      <td>{item.action}</td>
                      <td>{langoptions_preview[item.lang_id]}</td>
                      <td>{formatDateWithTime(item.time)}</td>
                      <td>{item.ad_codes?.length ? <JsonView data={item.ad_codes} shouldExpandNode={() => false} /> : '-'}</td>
                    </tr>
                  )
                })}
              </tbody> :
                !netAdmoveToLogsLoader && !netAdmoveToLogs.length ?
                  <NoDataFound colspan={999} /> : <TableLoader colspan={999} />}
            </table>
          </div>
      </SlDrawer>{console.log(todayExecutedCampaigns)}
      <SlDrawer
        open={showTodayExecutedDrawer}
        onSlRequestClose={() => { setShowTodayExecutedDrawer(false); setTodayExecutedCampaigns(null) }}
        onSlAfterHide={() => { }}
        style={{ "--size": "75vw" }}
        label={`Today Executed Campaigns - P${todayExecutedCampaigns?.position} ${slotOptions[todayExecutedCampaigns?.slot]}`}
      >
        <div className="p-4">
          {/* DFP Campaigns Section */}
          {todayExecutedCampaigns?.DFPRunningCampaigns?.length > 0 && (
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3 text-blue-600">DFP Running Campaigns</h4>
              <div className="overflow-x-auto">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Campaign Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {todayExecutedCampaigns.DFPRunningCampaigns.map((campaign, index) => (
                      <tr key={`dfp-running-${campaign.campaign_id}-${index}`}>
                        <td>{campaign.campaign_name || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {todayExecutedCampaigns?.DFPCampaigns?.length > 0 && (
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3 text-blue-600">DFP Campaigns Logs</h4>
              <div className="overflow-x-auto">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Campaign Name</th>
                      <th>User Name</th>
                      <th>Log Type</th>
                      <th>Previous Status</th>
                      <th>Log Updated</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {todayExecutedCampaigns.DFPCampaigns.map((campaign, index) => (
                      <tr key={`dfp-${campaign.id}-${index}`}>
                        <td>{campaign.campaign_name || '-'}</td>
                        <td>{campaign.user_name || '-'}</td>
                        <td>{campaign.log?.type || '-'}</td>
                        <td>{campaign.log?.previous || '-'}</td>
                        <td>{campaign.log?.updated || '-'}</td>
                        <td>{campaign.time ? formatDateWithTime(campaign.time) : '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Non-DFP Campaigns Section */}
          {todayExecutedCampaigns?.NonDFPCampaigns?.length > 0 && (
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3 text-green-600">Non-DFP Campaigns</h4>
              <div className="overflow-x-auto">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Campaign Name</th>
                      <th>Impressions</th>
                      <th>Clicks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {todayExecutedCampaigns.NonDFPCampaigns.map((campaign, index) => (
                      <tr key={`non-dfp-${index}`}>
                        <td>{campaign.campaign_name || '-'}</td>
                        <td>{campaign.total_imp || 0}</td>
                        <td>{campaign.total_click || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* No Data Message */}
          {(!todayExecutedCampaigns?.DFPCampaigns?.length && !todayExecutedCampaigns?.NonDFPCampaigns?.length && !todayExecutedCampaigns?.DFPRunningCampaigns?.length) && (
            <div className="d-flex justify-content-center py-8">
              <NoDataFound />
            </div>
          )}
        </div>
      </SlDrawer>
    </>
  );
}

export default AdUnit;
